import { createRouter, createWebHistory } from "vue-router";

import { initRouterGuardNew } from './router.guard'


const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: { name: 'start' },
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/views/HomeView.vue"),
    },
    {
      path: "/provider/:id",
      name: "providerdetails",
      component: () => import("@/views/ProviderView.vue"),
      props: true,
    },
    {
      path: "/provider/:id/details",
      name: "providerdata",
      component: () => import("@/views/ProviderDataView.vue"),
      props: true,
    },
    {
      path: "/chart",
      name: "chart",
      component: () => import("@/views/ChartView.vue"),
      meta: {
        dropDown: true,
      },
    },
    {
      path: "/start",
      name: "start",
      component: () => import("@/views/LoginView.vue")
    },
  ],
});

initRouterGuardNew(router)

export default router;
